import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_WAREHOUSE;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}

export const postSupply = (state, files, setLoad) => {
    return function (dispatch) {
        const suppliers = {
            material_id: state?.material_id,
            supplier_id: state?.supplier_id,
            company_project_id: state?.company_project_id,
            qty: state?.qty,
            cost: state?.cost,
            currency: state?.currency,
            date_of_supply: state?.date_of_supply,
            time_of_supply: state?.time_of_supply,
            place_of_supply: state?.place_of_supply,
            reason_of_supply: state?.reason_of_supply,
            files: files
        }
        const body = {
            suppliers: suppliers
        }
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        let user_id = localStorage.getItem('XX')
        console.log(suppliers)
        axios.post(`${END_POINT}/api/material-supplier`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'X-User-Id': user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_SUPPLY));
                //dispatch(loadWarehouses());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadSuppliers = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/material-supplier`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_SUPPLIERS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}



export const deleteSupply = (id, setloadDel, setIsDeleted, setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/material-supplier/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_SUPPLY));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putSupply = (id, state, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const suppliers = {
            material_id: state?.material_id,
            supplier_id: state?.supplier_id,
            company_project_id: state?.company_project_id,
            qty: state?.qty,
            cost: state?.cost,
            currency: state?.currency,
            date_of_supply: state?.date_of_supply,
            time_of_supply: state?.time_of_supply,
            place_of_supply: state?.place_of_supply,
            reason_of_supply: state?.reason_of_supply,
        }
        const body = {
            suppliers: suppliers
        }
        console.log(id)
        console.log(suppliers)
        axios.put(`${END_POINT}/api/material-supplier/${id}`,suppliers, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res.data.status === "Success") {
                    dispatch(edit(types.EDIT_SUPPLY));
                    dispatch(loadSuppliers());
                    notifysuccess(res.data.message)
                    setLoad(false)
                }
            }).catch((err) => {
                setLoad(false)
                notifyError(err.response.data.message)
            })
    }
}


export const filterSupply = (name, email, role, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (email !== '') queryParams.push(`filters[email]=${email}`);
        if (role !== '') queryParams.push(`filters[role]=${role}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/users?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
            dispatch(get(res.data.data, types.GET_SUPPLIERS));
        }).catch((err) => {
            ;
            setLoad(false);
        });
    };
};


